module.exports = __webpack_public_path__ + "static/media/exponent-custom.877a7c50.svg";